// tslint:disable: import-name
import React from 'react'
import { Mutation } from 'react-apollo'
import UPDATE_SENTINEL from '../../gql/mutations/updateSentinel'

export default ({ children }) => {
  return <Mutation mutation={UPDATE_SENTINEL}>{children}</Mutation>
}
